import type { ITransaction } from '@recargas-dominicanas/core/types';
import { formatCurrency, formatDate, formatTopupNumber } from '@recargas-dominicanas/core/utils';
import { ModalContent, ModalActions, OutlineButton } from '@recargas-dominicanas/core/components';
import { DetailModalItem } from '../detail-modal-item/detail-modal-item.component';
import { DetailModal } from '../detail-modal/detail-modal.component';

interface Props {
  open: boolean;
  transaction?: ITransaction;
  overlayEnterAnimation?: boolean;
  onAccept: () => void;
  onClose: () => void;
}

export function TopupCancelModal(props: Props) {

  const {
    open,
    transaction,
    overlayEnterAnimation,
    onAccept,
    onClose
  } = props;

  if (!transaction) return null;

  const topupNumber = formatTopupNumber(transaction.product, transaction.phone);

  return (
    <DetailModal
      open={open} 
      title='Cancelar recarga'
      overlayEnterAnimation={overlayEnterAnimation}
      onClose={onClose}>
      <ModalContent>
        <DetailModalItem title='Compañía' text={transaction.product.name}/>
        <DetailModalItem title={topupNumber.title} text={topupNumber.value}/>
        <DetailModalItem title='Monto' text={formatCurrency(transaction.amount)} color='green'/>
        <DetailModalItem title='Fecha' text={formatDate(transaction.date)}/>
      </ModalContent>
      <ModalActions>
        <OutlineButton 
          text='Confirmar' 
          onClick={onAccept}/>
      </ModalActions>
    </DetailModal>
  );
}
